import { hooks } from '@integro/core';
import { ModalManager } from './modal-manager';
import { modalMessages } from '../../messages';
import type { ErrorModalOptions } from './types';

export class ModalService {
  constructor(public readonly manager: ModalManager) {}

  show(data: { name: string; props?: Record<string, any> }) {
    return this.manager.show(data);
  }

  close(nameOrId: string, result?: any) {
    this.manager.close(nameOrId, result);
  }

  closeTop(result?: any) {
    this.manager.closeTop(result);
  }

  async confirm(props: {
    severity?: 'alert' | 'warning' | 'info';
    header?: string;
    message: string;
    btnOk?: string;
    btnCancel?: string;
    default?: 'ok' | 'cancel';
  }) {
    const res = await this.manager.show({ name: 'ConfirmDialog', props });
    return !!res?.value;
  }

  error(options: ErrorModalOptions) {
    const formatted = hooks.errorModalOptionsHook(options);
    let message = formatted.message;

    if (!message) {
      const exception = formatted.error;
      if (exception instanceof Error) {
        message = exception.message;
      } else if (typeof exception === 'string') {
        message = exception;
      } else if (typeof exception === 'boolean' || exception == null) {
        message = modalMessages.unknownError;
      } else if (typeof exception === 'object') {
        message = exception.message || exception.error || String(exception);
      } else {
        message = String(exception);
      }
    }

    return this.manager.show({
      name: 'MessageBox',
      props: {
        type: 'error',
        header: formatted.title || modalMessages.error,
        message,
        details: formatted.details,
      },
    });
  }
}
